import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ScrollContainer from "react-indiana-drag-scroll";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import Img from "react-cool-img";
import { Spinner } from "reactstrap";

import "./styles/CommonCarousel.scss";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { environment } from "../../enviornments/enviornment";

const CommonCarousel = (props) => {
    const [data, setData] = useState(null);
    let url = props.dataUrl || "https://api.themoviedb.org/3/trending/all/day";
    useEffect(() => {
        axios.get(`${url}?api_key=${environment.MovieDbApi}${props.parameter ? props.parameter : ""}`)
            .then(function (response) {
                // handle success
                setData(response.data.results);
            })
            .catch(function (error) {
                // handle error
                console.log(error);
            })
            .then(function () {
                // always executed
            });
    }, []);
    let layout;
    if (data) {
        layout = data.map((item, index) => {
            return (
                item.media_type == "movie" || Object.prototype.hasOwnProperty.call(item, "release_date") ?
                    <div className="common-carousel-item" key={index}>
                        <Link to={{
                            pathname: `/movies/${item.title ? item.title.split(" ").join("-") : item.name.split(" ").join("-")}/${item.id}`,
                            state: {
                                dataUrl: `https://api.themoviedb.org/3/movie/${item.id}`,
                            }
                        }}>
                            <Img className="image-loading" src={`https://image.tmdb.org/t/p/w500/${item.poster_path ? item.poster_path : item.backdrop_path}`} alt="React Cool Img" />
                            {/* <img src={`https://image.tmdb.org/t/p/w500/${item.poster_path ? item.poster_path : item.backdrop_path}`} alt="movie poster" /> */}
                            <p>{item.title ? item.title.slice(0, 15) : item.name.slice(0, 15)}</p>
                        </Link>
                    </div > : <div className="common-carousel-item" key={index}>
                        <Link to={{
                            pathname: `/tvshow/${item.title ? item.title.split(" ").join("-") : item.name.split(" ").join("-")}/${item.id}`,
                            state: {
                                dataUrl: `https://api.themoviedb.org/3/tv/${item.id}`,
                            }
                        }}>
                            <Img className="image-loading" src={`https://image.tmdb.org/t/p/w500/${item.poster_path ? item.poster_path : item.backdrop_path}`} alt="React Cool Img" />
                            <p>{item.title ? item.title.slice(0, 15) : item.name.slice(0, 15)}</p>
                        </Link>
                    </div>
            );
        });
    }
    return (
        !data ? <Spinner size="sm" color="secondary" /> : <div className="genere-container container-fluid mb-4 p-0">
            <div className="genere-header mb-3 p-2">
                <h5 className={`genere-title font-weight-bold ${props.color}`}>{props.genere ? props.genere : "All"}</h5>
                <FontAwesomeIcon icon={faArrowRight} className={`genere-icon ${props.color}`} size="lg" />
            </div>
            <ScrollContainer className="scroll-container common-carousel-container pl-2" horizontal={true}>
                {layout}
            </ScrollContainer>
        </div>
    );
};

export default CommonCarousel;

/** These are the color parameters you can accept
 *  Colors are coded in global.scss file with same class name

  g5-red
  g5-blue
  g5-orange
  g5-carolina
  g5-steelblue
  g5-high-carolina
  g5-high-carolina

 */
